import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { ColumnsType } from 'antd/es/table';
import { StatusImpactPill } from '~/app/components/dashboard/StatusImpactPill/StatusImpactPill';
import type { FailingSiteRowViewModel } from '../ScorecardPage.types';

export function useFailingSitesColumns(): ColumnsType<FailingSiteRowViewModel> {
  const { t } = useTranslation('dashboard');

  return useMemo(
    () => [
      {
        title: t('scorecard.failingSites.columns.site'),
        dataIndex: 'site',
        key: 'site',
      },
      {
        title: t('scorecard.failingSites.columns.region'),
        dataIndex: 'region',
        key: 'region',
      },
      {
        title: t('scorecard.failingSites.columns.performance'),
        dataIndex: 'performance',
        key: 'performance',
      },
      {
        title: t('scorecard.failingSites.columns.operator'),
        dataIndex: 'operator',
        key: 'operator',
      },
      {
        title: t('scorecard.failingSites.columns.status'),
        dataIndex: 'statusLabel',
        key: 'status',
        render: (_value, row) => (
          <StatusImpactPill tone={row.statusTone} label={row.statusLabel} />
        ),
      },
    ],
    [t],
  );
}
